import React from 'react';

// local dependencies
import { indexPageView as ApplicationView } from 'ui/views/layouts/indexPage';
import { globalComponentsProvider as GlobalComponentsProvider } from 'ui/views/global/globalComponentsProvider';
import { DOM_EVENTS } from 'constants/message-bus-events';
import { messageBus } from 'core/modules/message-bus';
import { addClass, removeClass } from 'utils/dom';
import { browserInfo } from 'utils/browserInfo';

export class IndexPageContainer extends React.Component {
    constructor( props ) {
		super( props );

		this.__bind();
	}

    // bind events and methods
    __bind() {
		log.debug( 'IndexPageContainer.__bind()' );

        // bind methods to the instance
        this.lockBodyScroll = this.lockBodyScroll.bind( this );

        // listen to body scroll lock event and add class to body
        messageBus.on( DOM_EVENTS.BODY_LOCK_SCROLL, this.lockBodyScroll, this );
    }

    // unbind events
    __unbind() {
		log.debug( 'IndexPageContainer.__unbind()' );

        messageBus.off( DOM_EVENTS.BODY_LOCK_SCROLL, this.lockBodyScroll, this );
    }

    /************************************************************/

    // lock `body` element scroll
    lockBodyScroll( { enable = true } = {} ) {
		log.debug( 'IndexPageContainer.lockBodyScroll()' );

        if( true === enable ) {
            addClass( document.body, 'mode--scroll-lock' );
        } else {
            removeClass( document.body, 'mode--scroll-lock' );
        }
    }

    /************************************************************/

    // when component mounts, add the `name of the browser` to the `<body>` element
    componentDidMount() {
        const _browserInfo = browserInfo();

        if ( _browserInfo.isBrowser ) {
            document.body.classList.add( `browser--${ _browserInfo.browserName }` );
        }
    }

    // render `IndexPageView` view with `loading` prop
    render() {
        return (
            <React.Fragment>

                {/* application view */}
                <ApplicationView />

                {/* global components */}
                <GlobalComponentsProvider />
            </React.Fragment>
        );
    }
}

// set display name
IndexPageContainer.displayName = 'IndexPageContainer';

// set default props
IndexPageContainer.defaultProps = {};
